import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'
import LifeCulture from '@/page/LifeCulture'
import CommunicationActivities from '@/page/CommunicationActivities'
import Grammar from '@/page/Grammar'
import GrammarDetail from '@/page/GrammarDetail'
import Conversation from '@/page/Conversation'
import ConversationDetail from '@/page/ConversationDetail'
import Hiragana from '@/page/Hiragana'
import HiraganaLearn from '@/page/HiraganaLearn'
import HiraganaResult from '@/page/HiraganaResult'
import Katakana from '@/page/Katakana'
import KatakanaLearn from '@/page/KatakanaLearn'
import KatakanaResult from '@/page/KatakanaResult'
import Kanji from '@/page/Kanji'
import KanjiAnswer from '@/page/KanjiAnswer'
import KanjiDetail from '@/page/KanjiDetail'


import Faq from '@/page/faq'
import guidance from '@/page/guidance'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/Login'
import otp from '@/page/otp'
import land from '@/page/land'
import Errors from '@/page/errors'
import Level from '@/page/level'
import LevelTest from '@/page/leveltest'
import select from '@/page/select'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        const mobile= to.query.mobile;
        if (mobile) {
          const res = await axios.post('https://jp-api.chineasier.com/api/user/fast_login', {
            mobile: mobile
          })
          if (res.data.code === 1){
            const leare_language = res.data.data.userinfo.leare_language
            if (leare_language == "chinese") {
              window.location.href = 'https://home.chineasier.com/#/?mobile='+mobile;
            }else if (leare_language == "japanese"){
              localStorage.setItem('token', res.data.data.userinfo.token)
              localStorage.setItem('mobile',res.data.data.userinfo.mobile)
              localStorage.setItem('avatar',res.data.data.userinfo.avatar)
            }
          }
        }
        next()
      }
    },
    {
      path: '/LifeCulture',
      name: 'LifeCulture',
      component: LifeCulture,
      meta: {
        title: 'LifeCulture'
      }
    },{
      path: '/CommunicationActivities',
      name: 'CommunicationActivities',
      component: CommunicationActivities,
      meta: {
        title: 'CommunicationActivities'
      }
    },{
      path: '/Grammar',
      name: 'Grammar',
      component: Grammar,
      meta: {
        title: 'Grammar'
      }
    },{
      path: '/GrammarDetail',
      name: 'GrammarDetail',
      component: GrammarDetail,
      meta: {
        title: 'GrammarDetail'
      }
    },{
      path: '/Conversation',
      name: 'Conversation',
      component: Conversation,
      meta: {
        title: 'Conversation'
      }
    },{
      path: '/ConversationDetail',
      name: 'ConversationDetail',
      component: ConversationDetail,
      meta: {
        title: 'ConversationDetail'
      }
    },{
      path: '/Hiragana',
      name: 'Hiragana',
      component: Hiragana,
      meta: {
        title: 'Hiragana'
      }
    },{
      path: '/HiraganaLearn',
      name: 'HiraganaLearn',
      component: HiraganaLearn,
      meta: {
        title: 'HiraganaLearn'
      }
    },{
      path: '/HiraganaResult',
      name: 'HiraganaResult',
      component: HiraganaResult,
      meta: {
        title: 'HiraganaResult'
      }
    },{
      path: '/Katakana',
      name: 'Katakana',
      component: Katakana,
      meta: {
        title: 'Katakana'
      }
    },{
      path: '/KatakanaLearn',
      name: 'KatakanaLearn',
      component: KatakanaLearn,
      meta: {
        title: 'KatakanaLearn'
      }
    },{
      path: '/KatakanaResult',
      name: 'KatakanaResult',
      component: KatakanaResult,
      meta: {
        title: 'KatakanaResult'
      }
    },{
      path: '/Kanji',
      name: 'Kanji',
      component: Kanji,
      meta: {
        title: 'Kanji'
      }
    },{
      path: '/KanjiAnswer',
      name: 'KanjiAnswer',
      component: KanjiAnswer,
      meta: {
        title: 'KanjiAnswer'
      }
    },{
      path: '/KanjiDetail',
      name: 'KanjiDetail',
      component: KanjiDetail,
      meta: {
        title: 'KanjiDetail'
      }
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },{
      path: '/guidance',
      name: 'guidance',
      component: guidance,
      meta: {
        title: 'guidance'
      }
    },
    {
      path: '/errors',
      name: 'errors',
      component: Errors,
      meta: {
        title: 'errors'
      }
    },
    {
      path: '/level',
      name: 'level',
      component: Level,
      meta: {
        title: 'level'
      }
    },
    {
      path: '/leveltest',
      name: 'leveltest',
      component: LevelTest,
      meta: {
        title: 'leveltest'
      }
    },
    {
      path: '/select',
      name: 'select',
      component: select,
      meta: {
        title: 'select'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js